import React, { useEffect, useState } from "react";
import axios from "axios";
import "./DeleteSlider.css";

function DeleteSlider() {
  const [sliders, setSliders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Fetch sliders from the API
  const fetchSliders = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        "https://api.swasthmitra.com/api/mainslider/get"
      );
      setSliders(response.data.sliders);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching sliders:", err);
      setError("Failed to fetch sliders. Please try again later.");
      setLoading(false);
    }
  };

  // Delete slider by ID
  const deleteSlider = async (id) => {
    if (window.confirm("Are you sure you want to delete this slider?")) {
      try {
        await axios.delete(`https://api.swasthmitra.com/api/mainslider/delete/${id}`);
        alert("Slider deleted successfully!");
        fetchSliders(); // Refresh the slider list after deletion
      } catch (err) {
        console.error("Error deleting slider:", err);
        alert("Failed to delete the slider. Please try again.");
      }
    }
  };

  useEffect(() => {
    fetchSliders();
  }, []);

  if (loading) return <p>Loading sliders...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="delete-slider-container">
      <h2>Delete Sliders</h2>
      {sliders.length === 0 ? (
        <p>No sliders found.</p>
      ) : (
        <table className="slider-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Image</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {sliders.map((slider) => (
              <tr key={slider._id}>
                <td>{slider.name}</td>
                <td>{slider.description}</td>
                <td>
                  <img
                    src={slider.imageUrl}
                    alt={slider.name}
                    style={{ width: "100px", height: "50px" }}
                  />
                </td>
                <td>
                  <button
                    className="delete-btn"
                    onClick={() => deleteSlider(slider._id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default DeleteSlider;
